import { toValue, type MaybeRefOrGetter, ref, type Ref } from 'vue';

type FocusEmit = {
  (event: 'focus', e: FocusEvent): void;
  (event: 'blur', e: FocusEvent): void;
};

export function useFocusControl(
  model: Ref<string>,
  controlRef: Ref<HTMLInputElement | HTMLTextAreaElement | null>,
  emit: FocusEmit,
  options?: { trim?: MaybeRefOrGetter<boolean> }
) {
  const isFocused = ref(false);
  const ignoreBlur = ref(false);
  const onFieldMousedown = (event: MouseEvent) => {
    if (event.target !== controlRef.value) ignoreBlur.value = true;
  };
  const onFieldClick = (event: MouseEvent) => {
    if (event.target !== controlRef.value) controlRef.value?.focus();
  };
  const onFocus = (event: FocusEvent) => {
    ignoreBlur.value = false;
    if (isFocused.value) return;
    isFocused.value = true;
    emit('focus', event);
  };
  const onBlur = (event: FocusEvent) => {
    if (ignoreBlur.value) return;
    isFocused.value = false;
    emit('blur', event);
    const value = (event.target as HTMLInputElement).value;
    model.value = toValue(options?.trim) === false ? value : value.trim();
  };

  return { isFocused, onFieldMousedown, onFieldClick, onFocus, onBlur };
}
